module.exports = __webpack_public_path__ + "static/media/close-icon.b48416f3.svg";